export const DEFAULT_VALIDATION_DISPLAY_MESSAGES = {
    default: {
        "required": {
            "en": `$property is required`,
            "fr": `$property est requis(e)`,
        },
        "invalid": {
            "en": `$property is not valid`,
            "fr": `$property n'est pas valide`,
        },
    },
    rules: {
        "arrayContains": {
            "en": `$property must contain the following values: $constraint1`,
            "fr": `$property doit contenir les valeurs suivantes : $constraint1`,
        },
        "arrayMaxSize": {
            "en": `$property must contain not more than $constraint1 elements`,
            "fr": `$property ne doit pas contenir plus de $constraint1 élément(s)`,
        },
        "arrayMinSize": {
            "en": `$property must contain at least $constraint1 elements`,
            "fr": `$property doit contenir au moins $constraint1 élément(s)`,
        },
        "arrayNotContains": {
            "en": `$property should not contain any of the following values: $constraint1`,
            "fr": `$property ne doit pas contenir une des valeurs suivantes : $constraint1`,
        },
        "arrayNotEmpty": {
            "en": `$property should not be empty`,
            "fr": `$property ne doit pas être vide`,
        },
        "arrayUnique": {
            "en": `All elements of $property must be unique`,
            "fr": `Tous les éléments de $property doivent être uniques`,
        },
        "equals": {
            "en": `$property must be equal to $constraint1`,
            "fr": `$property doit être égal(e) à $constraint1`,
        },
        "isEmpty": {
            "en": `$property must be empty`,
            "fr": `$property doit être vide`,
        },
        "isIn": {
            "en": `$property must be one of the following values: $constraint1`,
            "fr": `$property doit être une des valeurs suivantes : $constraint1`,
        },
        "isLatitude": {
            "en": `$property must be a latitude`,
            "fr": `$property doit être une latitude`,
        },
        "isLatLong": {
            "en": `$property must be a valid geographical position`,
            "fr": `$property doit être une position géographique valide`,
        },
        "isLongitude": {
            "en": `$property must be a longitude`,
            "fr": `$property doit être une longitude`,
        },
        "isNotEmpty": {
            "en": `$property should not be empty`,
            "fr": `$property ne doit pas être vide`,
        },
        "isNotIn": {
            "en": `$property should not be one of the following values: $constraint1`,
            "fr": `$property ne doit pas être une des valeurs suivantes : $constraint1`,
        },
        "notEquals": {
            "en": `$property should not be equal to $constraint1`,
            "fr": `$property ne doit pas être égal(e) à $constraint1`,
        },
        "maxDate": {
            "en": `Maximal allowed date for $property is $constraint1`,
            "fr": `$property ne peut être supérieur(e) à $constraint1`,
        },
        "minDate": {
            "en": `Minimal allowed date for $property is $constraint1`,
            "fr": `$property ne peut être inférieur(e) à $constraint1`,
        },
        "isDivisibleBy": {
            "en": `$property must be divisible by $constraint1`,
            "fr": `$property doit être divisible par $constraint1`,
        },
        "isNegative": {
            "en": `$property must be a negative number`,
            "fr": `$property doit être un nombre négatif`,
        },
        "isPositive": {
            "en": `$property must be a positive number`,
            "fr": `$property doit être un nombre positif`,
        },
        "max": {
            "en": `$property must not be greater than $constraint1`,
            "fr": `$property ne peut être supérieur(e) à $constraint1`,
        },
        "min": {
            "en": `$property must not be less than $constraint1`,
            "fr": `$property ne peut être inférieur(e) à $constraint1`,
        },
        "isInstance": null,
        "isNotEmptyObject": null,
        "isArray": null,
        "isBoolean": null,
        "isDate": {
            "en": `$property must be a valid date`,
            "fr": `$property doit être une date valide`,
        },
        "isEnum": null,
        "isInt": {
            "en": `$property must be an integer number`,
            "fr": `$property doit être un nombre entier`,
        },
        "isNumber": {
            "en": `$property must be a number`,
            "fr": `$property doit être un nombre`,
        },
        "isObject": null,
        "isString": null,
        "contains": {
            "en": `$property must contain the following value: $constraint1`,
            "fr": `$property doit contenir la valeur suivante : $constraint1`,
        },
        "isAlpha": {
            "en": `$property must contain only letters`,
            "fr": `$property ne doit contenir que des lettres`,
        },
        "isAlphanumeric": {
            "en": `$property must contain only letters and numbers`,
            "fr": `$property ne doit contenir que des chiffres et lettres`,
        },
        "isAscii": null,
        "isBase32": null,
        "isBase64": null,
        "isBIC": {
            "en": `$property must be a valid BIC or SWIFT code`,
            "fr": `$property doit être un BIC ou code SWIFT valide`,
        },
        "isBooleanString": null,
        "isBtcAddress": {
            "en": `$property must be a BTC address`,
            "fr": `$property doit être une adresse BTC`,
        },
        "isByteLength": {
            "en": `$property's byte length must fall into ($constraint1, $constraint2) range`,
            "fr": `La longueur en octets de $property doit se situer dans l'intervalle ($constraint1, $constraint2)`,
        },
        "isCreditCard": {
            "en": `$property must be a valid credit card number`,
            "fr": `$property doit être un numéro de carte de crédit valide`,
        },
        "isCurrency": {
            "en": `$property must be a currency`,
            "fr": `$property doit être une devise`,
        },
        "isDataURI": null,
        "isDateString": {
            "en": `$property must be a valid date`,
            "fr": `$property doit être une date valide`,
        },
        "isDecimal": {
            "en": `$property must be a decimal number`,
            "fr": `$property doit être un nombre décimal`,
        },
        "isEAN": {
            "en": `$property must be an EAN (European Article Number)`,
            "fr": `$property doit être un EAN (European Article Number)`,
        },
        "isEmail": {
            "en": `$property must be a valid email`,
            "fr": `$property doit être un email valide`,
        },
        "isEthereumAddress": {
            "en": `$property must be an Ethereum address`,
            "fr": `$property doit être une adresse Ethereum`,
        },
        "IsFirebasePushId": null,
        "isFqdn": {
            "en": `$property must be a valid domain name`,
            "fr": `$property doit être un nom de domaine valide`,
        },
        "isFullWidth": null,
        "isHalfWidth": null,
        "isHash": null,
        "isHexadecimal": {
            "en": `$property must be a hexadecimal number`,
            "fr": `$property doit être un nombre hexadécimal`,
        },
        "isHexColor": {
            "en": `$property must be a hexadecimal color`,
            "fr": `$property doit être une couleur hexadécimale`,
        },
        "isHSL": {
            "en": `$property must be a HSL color`,
            "fr": `$property doit être une couleur HSL`,
        },
        "isIBAN": {
            "en": `$property must be a valid IBAN`,
            "fr": `$property doit être un IBAN valide`,
        },
        "isIdentityCard": {
            "en": `$property must be a valid identity card number`,
            "fr": `$property doit être un numéro de carte d'identité valide`,
        },
        "isIp": {
            "en": `$property must be an IP address`,
            "fr": `$property doit être une adresse IP`,
        },
        "isIsbn": {
            "en": `$property must be an ISBN`,
            "fr": `$property doit être un ISBN`,
        },
        "isIsin": {
            "en": `$property must be an ISIN (stock/security identifier)`,
            "fr": `$property doit être un ISIN (identifiant d'action/de titre)`,
        },
        "isISO31661Alpha2": {
            "en": `$property must be a valid country`,
            "fr": `$property doit être un pays valide`,
        },
        "isISO31661Alpha3": {
            "en": `$property must be a valid country`,
            "fr": `$property doit être un pays valide`,
        },
        "isIso8601": {
            "en": `$property must be a valid date`,
            "fr": `$property doit être une date valide`,
        },
        "isISRC": {
            "en": `$property must be an ISRC`,
            "fr": `$property doit être un ISRC`,
        },
        "isISSN": {
            "en": `$property must be a ISSN`,
            "fr": `$property doit être un ISSN`,
        },
        "isJson": null,
        "isJwt": null,
        "isLocale": null,
        "isLowercase": {
            "en": `$property must be lowercase`,
            "fr": `$property doit être en minuscules`,
        },
        "isMacAddress": {
            "en": `$property must be a MAC Address`,
            "fr": `$property doit être une adresse MAC`,
        },
        "isMagnetURI": null,
        "isMilitaryTime": {
            "en": `$property must be a valid time in the format HH:MM`,
            "fr": `$property doit être une heure valide au format HH:MM`,
        },
        "isMimeType": null,
        "isMobilePhone": {
            "en": `$property must be a valid mobile phone number`,
            "fr": `$property doit être un numéro de téléphone mobile valide`,
        },
        "isMongoId": null,
        "isMultibyte": null,
        "isNumberString": {
            "en": `$property must be a number`,
            "fr": `$property doit être un nombre`,
        },
        "isOctal": {
            "en": `$property must be valid octal number`,
            "fr": `$property doit être un nombre octal valide`,
        },
        "isPassportNumber": {
            "en": `$property must be a valid passport number`,
            "fr": `$property doit être un numéro de passeport valide`,
        },
        "isPhoneNumber": {
            "en": `$property must be a valid phone number`,
            "fr": `$property doit être un numéro de téléphone valide`,
        },
        "isPort": {
            "en": `$property must be a port`,
            "fr": `$property doit être un numéro de port`,
        },
        "isPostalCode": {
            "en": `$property must be a valid postal code`,
            "fr": `$property doit être un code postal valide`,
        },
        "isRFC3339": {
            "en": `$property must be a valid date`,
            "fr": `$property doit être une date valide`,
        },
        "isRgbColor": {
            "en": `$property must be a valid color`,
            "fr": `$property doit être une couleur valide`,
        },
        "isSemVer": {
            "en": `$property must be a version number following the SemVer Specification`,
            "fr": `$property doit être un numéro de version conforme à la spécification SemVer`,
        },
        "isSurrogatePair": null,
        "isUppercase": {
            "en": `$property must be uppercase`,
            "fr": `$property doit être en majuscules`,
        },
        "isUrl": {
            "en": `$property must be an URL address`,
            "fr": `$property doit être une adresse URL`,
        },
        "isUuid": {
            "en": `$property must be a valid ID`,
            "fr": `$property doit être un ID valide`,
        },
        "isVariableWidth": null,
        "matches": {
            "en": `$property format is not valid`,
            "fr": `Le format de $property n'est pas valide`,
        },
        "maxLength": {
            "en": `$property must be shorter than or equal to $constraint1 characters`,
            "fr": `$property doit être plus court ou égal à $constraint1 caractères`,
        },
        "minLength": {
            "en": `$property must be longer than or equal to $constraint1 characters`,
            "fr": `$property doit être plus long ou égal à $constraint1 caractères`,
        },
        "notContains": {
            "en": `$property should not contain the following value: $constraint1`,
            "fr": `$property ne doit pas contenir la valeur suivante : $constraint1`,
        },
        "isLength": ([constraint1, constraint2]) => {
            if (constraint1 != undefined && constraint2 != undefined) {
                return {
                    "en": `$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters`,
                    "fr": `$property doit être d'une longueur supérieure ou égale à $constraint1 et d'une longueur inférieure ou égale à $constraint2 caractères`,
                };
            }
            else if (constraint1 != undefined) {
                return {
                    "en": `$property must be longer than or equal to $constraint1 characters`,
                    "fr": `$property doit être plus long ou égal à $constraint1 caractères`,
                };
            }
            else if (constraint2 != undefined) {
                return {
                    "en": `$property must be shorter than or equal to $constraint2 characters`,
                    "fr": `$property doit être plus court ou égal à $constraint2 caractères`,
                };
            }
            else {
                return null;
            }
        },
    },
};
//# sourceMappingURL=messages.js.map